import CurrentPrice from "./CurrentPrice.jsx";
import InstanceInputRender from "./InstanceInputRender";

const InstanceDetailCol1 = props => {
  const { formik, isDisabled, submitOnBlur = false } = props;

  const { artists: artworkArtists = [] } =
    formik?.values?.edition?.artwork || {};
  const inputs = [
    ...artworkArtists.map((artist, index) => {
      // As the artists dropdown is always disabled here just populate options with selected artist
      const artistOptions = artist?.name
        ? [{ label: artist.name, value: artist.id }]
        : [];

      return {
        label: "Artist",
        name: `edition.artwork.artists[${index}].id`,
        type: "multi-select",
        options: artistOptions,
        checkbox: {
          disabled: true,
          name: `edition.artwork.artists[${index}].droitdesuite`,
          label: "DdS",
        },
        disabled: true,
        submitOnBlur,
      };
    }),
    {
      label: "Title",
      name: "edition.artwork.title",
      type: "textarea",
      rows: 5,
      disabled: isDisabled,
      submitOnBlur,
    },
    {
      label: "Year",
      name: "edition.year",
      type: "text",
      disabled: isDisabled,
      submitOnBlur,
    },
    {
      label: "Medium",
      name: "edition.artwork.medium",
      type: "textarea",
      rows: 5,
      disabled: isDisabled,
      submitOnBlur,
    },
  ];

  return (
    <div className={`grid h-fit grid-cols-1 gap-4`}>
      <InstanceInputRender inputs={inputs} formik={formik} />
      <CurrentPrice value={formik?.values?.value} />
    </div>
  );
};

export default InstanceDetailCol1;
